import {AfterViewInit, Component, ElementRef, HostListener, Renderer2, ViewChild} from '@angular/core';
import {NavigationService} from './navigation/navigation.service';
import {Router} from '@angular/router';
import {AboutComponent} from './about/about.component';
import {TariffComponent} from './tariff/tariff.component';
import {InfoComponent} from './info/info.component';
import {NavigationComponent} from './navigation/navigation.component';

@Component({
  template: ''
})
export abstract class BaseComponent implements AfterViewInit {
  @ViewChild(NavigationComponent) scrollToTop!: ElementRef<NavigationComponent>;
  @ViewChild(AboutComponent) about!: ElementRef<AboutComponent>;
  @ViewChild(TariffComponent) tariff!: ElementRef<TariffComponent>;
  @ViewChild(InfoComponent) help!: ElementRef<InfoComponent>;

  constructor(
    public navigationService: NavigationService,
    protected router: Router,
    public renderer: Renderer2) {
    this.renderer.removeClass(document.body, 'document-body');
  }

  @HostListener('window:scroll', ['$event'])
  onScroll(event: any): void {
    this.navigationService.scrollToTopButton = window.pageYOffset > 100;
  }

  ngAfterViewInit(): void {
    this.navigationService.scrollToTop = this.scrollToTop;
    this.navigationService.about = this.about;
    this.navigationService.help = this.help;
    if (this.tariff) {
      this.navigationService.tariff = this.tariff;
    }
  }
}
